const PDF_URL_RELEASE_DELAY_MS = 60_000;

const secureTab = (tab) => {
  if (!tab) return null;
  try {
    tab.opener = null;
  } catch (error) {
    // Some browsers expose opener as read-only. The tab can still be used.
  }
  return tab;
};

const releaseUrlLater = (url) => {
  window.setTimeout(() => URL.revokeObjectURL(url), PDF_URL_RELEASE_DELAY_MS);
};

export const reservePdfTab = () => {
  try {
    return secureTab(window.open('', '_blank'));
  } catch (error) {
    return null;
  }
};

export const loadPdfInReservedTab = (tab, url) => {
  if (!tab || tab.closed || !url) return false;

  try {
    tab.location.replace(url);
    if (typeof tab.focus === 'function') tab.focus();
    releaseUrlLater(url);
    return true;
  } catch (error) {
    return false;
  }
};

export const openPdfInNewTab = (url) => {
  const tab = reservePdfTab();
  if (!tab) return false;

  if (loadPdfInReservedTab(tab, url)) return true;

  try {
    tab.close();
  } catch (error) {
    // Nothing else to clean up when the browser owns the failed tab.
  }
  return false;
};

export { PDF_URL_RELEASE_DELAY_MS };
